export const backgroundImageToScreenRatioAtDesktopBreakpoint = 356 / 812;
export const iconViewWidthUnitsMobile = (24 / 530) * 100;
export const iconViewWidthUnitsDesktopBeforeModalMaxWidth = backgroundImageToScreenRatioAtDesktopBreakpoint * iconViewWidthUnitsMobile;
export const spacingBetweenIconAndInitialsViewWidthUnits = 0.5;
//# sourceMappingURL=dimensions.js.map